import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import TeaserPhoto from 'components/TeaserPhoto';
import { IconButton } from 'components/Button';
import './index.sass';
import { Skeleton } from '@mui/material';
import { times } from 'utils/render';

const { block, el } = bem('form-specialist-teaser');
export const FormSpecialistTeaser = ({ specialist, onClick, mod}) => {
    const { name, specialisation, direction, pairDetails, length, slug } = specialist.data;
    const { photo } = specialist;
    const { price } = specialist.data.servicesSet[0];
    const worksWithPairs = pairDetails !== 'не работает с парами';
    const forceLineBreakName = name.replace(/\s/, '\n').replace('-', '&#8209;');

    return (
        <Layout
            mod={mod}
            slug={slug}
            PhotoBlock={PhotoBlock({photo, name, slug})}
            NameBlock={NameBlock({specialisation, name: forceLineBreakName})}
            DescriptionBlock={DescriptionBlock({direction})}
            PriceBlock={PriceBlock({price, length, worksWithPairs})}
            ButtonBlock={ButtonBlock({onClick})}
        />
    )
}

export const TeaserSkeleton = ({ mod }) => {
    const PhotoBlock = <Skeleton variant='rectangular' height={'100%'} style={{borderRadius: '20px'}}><TeaserPhoto /></Skeleton>;
    const NameBlock = <>
        <Skeleton key={1} height={10} style={{marginBottom: '5px', fontSize: '12px', lineHeight: '14px'}} width={`50%`}/>
        <div>
            <Skeleton key={2} height={10} style={{marginBottom: '5px', fontSize: '24px', lineHeight: '30px'}} width={`30%`}/>
            <Skeleton key={3} height={10} style={{marginBottom: '5px', fontSize: '24px', lineHeight: '30px'}} width={`70%`}/>
        </div>
    </>
    const DescriptionBlock = times((key) => <Skeleton key={key} style={{marginBottom: '3px', fontSize: '10px', lineHeight: '12px'}} width={`${70 + Math.random() * 30}%`}/>, 3)
    const PriceBlock = <Skeleton style={{marginBottom: '3px', fontSize: '10px', lineHeight: '12px'}} width={'100%'}/>
    const ButtonBlock = <Skeleton variant='rectangular' width={'100%'} height={42} style={{borderRadius: '10px'}}/>
    return (
        <Layout
            mod={mod}
            PhotoBlock={PhotoBlock}
            NameBlock={NameBlock}
            DescriptionBlock={DescriptionBlock}
            PriceBlock={PriceBlock}
        />
    )
}

const Layout = ({mod, PhotoBlock, NameBlock, DescriptionBlock, PriceBlock, ButtonBlock }) => {
    return (
        <div className={block([mod])}>
            <div className={el('top-block')}>
                <div className={el('inline-block')}>
                    <div className={el('photo')}>
                        { PhotoBlock }
                    </div>
                    <div className={el('spacer')} />
                    <div className={el('name-block')}>
                        { NameBlock }
                    </div>
                </div>
                <div className={el('description')}>
                    { DescriptionBlock }
                </div>
            </div>
            <div className={el('price-block')}>
                { PriceBlock }
            </div>
            <div className={el('button')}>
                { ButtonBlock }
            </div>
        </div>
    )
}

const PhotoBlock = ({photo, name, slug}) =>
    <>
        <IconButton target='_blank' className={el('specialist-info')} name={'info'} to={`/specialists/${slug}`}/>
        <TeaserPhoto src={photo} alt={`Фото специалиста ${name}`} />
    </>

const NameBlock = ({specialisation, name}) => (
    <>
        <div className={el('speciality')}><Text>{specialisation}</Text></div>
        <div className={el('name')}><Text serif={true} dangerouslySetInnerHTML={{__html: name}} /></div>
    </>
)

const DescriptionBlock = ({direction}) => <Text>{direction}</Text>;

const PriceBlock = ({price, length, worksWithPairs}) => (
    <>
        <div className={el('price-single')}>
            <Icon name={'user'} />
            <Text className={el('price')}>{`${price} ₽`}</Text>
            <Text className={el('duration')}>{` ${length} мин`}</Text>
        </div>
        <div className={el('price-pair')}>
            <Icon name={'users'} />
            <Text className={el('price')}>{worksWithPairs ? `${price} ₽` : '-'}</Text>
            { worksWithPairs && <Text className={el('duration')}>{` ${ length } мин`}</Text> }
        </div>
    </>
)

const ButtonBlock = ({onClick}) => <IconButton name={'arrow-right'} mod={'gold'} onClick={onClick} type={'button'}><Text>Записаться</Text></IconButton>

